import { faCircleUser, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './Navbar.css';

const Navbar = () => {
    return (
        <div className="home-header">
            <div>
                <div>
                    <img src="/emprendedores/UABClogos/FCITEC.png" alt="logo" />
                </div>

                <div className="home-login">
                    {/* <FontAwesomeIcon icon={faCircleUser} size="2xl" style={{ color: "#ffffff", }} /> */}
                    <a href="/emprendedores/admin/login">
                        <FontAwesomeIcon icon={faUser} size="2xl" style={{ color: "#ffffff", }} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Navbar;